var klevu_storeTranslations = {
  "Clear all": "Borrar todo",
  "Narrow by": "Filtros",
  "Add to Cart": "Agregar al carro",
  "Relevance": "Recomendados",
  "Price: Low to high": "Precio de menor a mayor",
  "Price: High to low": "Precio de mayor a menor",
}

const interval = setInterval(function () {
  (function fixTwoKlevuPrices() {
    const selectors = [".kuSalePrice", ".kuOrigPrice"];
    let found = false;
    function formatCLP(el) {
      let txt = el.textContent;
      // Remove CLP and spaces 
      txt = txt.replace(/CLP/gi, "").trim();
      // Keep only numbers and separators 
      txt = txt.replace(/[^0-9.,]/g, "");
      // Remove .00 or ,00 
      txt = txt.replace(/[.,]\d{2}$/, "");
      // Remove thousand separators 
      let raw = txt.replace(/[.,]/g, "");
      if (!raw) return;
      let num = parseInt(raw, 10);
      let formatted = new Intl.NumberFormat("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(num);
      el.textContent = "$ " + formatted;
    }
    selectors.forEach(sel => {
      const elements = document.querySelectorAll(sel);
      if (elements.length > 0) found = true;
      elements.forEach(formatCLP);
    });
    if (found) {
      console.log("Fixed sale + original Klevu prices");
      clearInterval(interval); // stop checking 
    }
  })();
}, 200);